<template>
  <section v-if="inclusions.length > 0">
    <div class="inclusions-items">
      <div
        v-for="(inclusion, index) of inclusions"
        :key="index"
        class="pt-2 pb-2 card card--border"
      >
        <div class="card-content p-2">
          <p class="title is-size-6 has-text-weight-semibold mb-2">
            {{ modifiedString(inclusion.inclusion_label) }}
          </p>
          <div class="content">
            <p v-html="inclusion.notes" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    inclusions: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      propertyInclusion: [],
      phrasesToRemove: ["(précisez)", "(specify)"],
    };
  },
  created() {
    this.propertyInclusion = this.inclusions;
  },
  methods: {
    modifiedString(inputString) {
      console.log(inputString);
      if (
        inputString.includes("(précisez)") ||
        inputString.includes("(specify)")
      ) {
        let newString = inputString.replace("(précisez)", "");
        newString = newString.replace("(specify)", "");
        return newString.capitalize();
      }
      return inputString.capitalize();
    },
  },
};
</script>
<style scoped>
.card--border {
  margin-bottom: 12px;
  border-top: none;
  border-right: none;
  border-left: none;
  border-radius: 0;
}
</style>
